<template>
	<router-view/>
</template>
